export enum ECalendarMode {
  Day,
  DayTime,
  Month,
  Time
}
